import { collections } from "@/mocks/collections";
import { SectionHead, CollectionCard } from "@/components/feature/cards";

export default function CollectionsShowcase() {
  const list = collections.filter((c) => c.id !== "featured");
  const featured = collections.find((c) => c.id === "featured");

  return (
    <section className="border-y border-background-200 bg-background-100/60">
      <div className="container-x py-10 md:py-14">
        <SectionHead
          kicker="分类整理 · 瓜田归档"
          title="专题合集，按主题一次看个够"
          linkTo="/collection/featured"
          linkLabel="全部合集"
        />

        {featured ? (
          <div className="mb-5 grid gap-5 lg:grid-cols-2">
            <CollectionCard collection={featured} />
            <CollectionCard collection={list[0]} />
          </div>
        ) : null}

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.slice(1).map((c) => (
            <CollectionCard key={c.id} collection={c} />
          ))}
          {/* CTA tile */}
          <Link
            to="/about"
            className="group relative flex min-h-[220px] flex-col justify-between overflow-hidden rounded-lg border border-dashed border-secondary-400/60 bg-secondary-100/40 p-6 transition-colors hover:border-primary-400 hover:bg-primary-100/40"
          >
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-secondary-700">
                About Us
              </p>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950">
                关于吃瓜日报：我们如何为你整理这些瓜
              </h3>
            </div>
            <span className="mt-6 inline-flex items-center gap-1 text-sm font-bold text-primary-600">
              去看看
              <i className="ri-arrow-right-up-line transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}